import { Component, Input } from '@angular/core';
import { CiReport } from '../../ci-report';

@Component({
  selector: 'app-property-investment',
  standalone: true,
  templateUrl: './property-investment.component.html',
  styleUrl: './property-investment.component.scss'
})
export class PropertyInvestmentComponent {
  @Input() report: CiReport | null = null;
  @Input() loading = false;
  @Input() error = '';

  get rentalMetrics() {
    return (this.report?.valuation ?? []).filter(metric => ['Monthly Rent', 'Annual Rent', 'Rental Yield', 'Rental Strength'].includes(metric.label));
  }

  get scores(): { label: string; score: number }[] {
    return this.report?.investmentScores ?? [];
  }

  get evidence() {
    if (this.report?.propertyType === 'Plots' || this.report?.propertyType === 'Independent House') return this.report?.assessmentMetrics ?? [];
    const pricing = this.report?.pricing ?? [];
    const benchmark = this.metric(pricing, 'Benchmark PSF');
    return [
      { label: 'Benchmark PSF', value: benchmark },
      this.report?.propertyType === 'Primary'
        ? { label: 'Average PSF of Similar Properties', value: this.metric(pricing, 'Average PSF of Similar Properties') }
        : { label: 'Last Transaction PSF', value: this.metric(pricing, 'Last Transacted PSF') },
      { label: 'Market Difference', value: this.metric(pricing, 'Ask vs Benchmark') },
    ].filter(metric => metric.value !== 'Not available');
  }

  private metric(metrics: { label: string; value: string }[] | undefined, label: string): string {
    return metrics?.find(metric => metric.label === label)?.value ?? 'Not available';
  }

  value(label: string): string {
    return this.metric(this.report?.valuation, label);
  }
}
